import { EnvironmentEnums } from "models/enums";

const EnvHelper = {
  getEnvironment: () => {
    return import.meta.env.VITE_ENV || import.meta.env.MODE;
  },

  getIsTestEnvironment: () => {
    return EnvHelper.getEnvironment() === EnvironmentEnums.Environment.Test;
  },

  getIsProductionEnvironment: () => {
    return EnvHelper.getEnvironment() === EnvironmentEnums.Environment.Production;
  },

  getVersion: () => {
    return import.meta.env.VITE_VERSION || "0.0.0";
  },

  getName: () => {
    return import.meta.env.VITE_APP_NAME || "wint-client-web";
  },

  getBranch: () => {
    return import.meta.env.VITE_BRANCH;
  },

  getSentryDSN: () => {
    return import.meta.env.VITE_SENTRY_DSN;
  },
};

export default EnvHelper;
